import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { useMMDataContext } from 'src/features/MM/contexts/MMDataContext';
import { ValueTickFormatter } from 'src/utils/TickFormatters';
import { romiDef } from 'src/utils/metricDefinitions';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';
import { useAggregationLevelContext } from '../../contexts/AggregationLevelContext';
import { useGetDateAxisFormatter } from '../../hooks/useGetDateAxisFormatter';
import { getAggregateLevelData } from '../../utils/getAggregateLevelData';
import { TimeseriesDataTableModal } from '../molecules/TimeseriesDataTableModal';

const title = 'ROMI';

export const ROMIBox: React.FC = () => {
  const { metricLabel } = useKpiMetricLabels();
  const { romi } = useMMDataContext();
  const { aggregateLevel } = useAggregationLevelContext();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return getAggregateLevelData(romi, aggregateLevel);
  }, [romi, aggregateLevel]);

  const xAxisFormatter = useGetDateAxisFormatter();

  return (
    <KeyMetricGraphBox
      title={title}
      data={data}
      xAxisFormatter={xAxisFormatter}
      yAxisFormatter={ValueTickFormatter}
      isError={romi.isError}
      isLoading={romi.isLoading}
      infoHeader="Return on Marketing Investment"
      infoText={romiDef(metricLabel)}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={ValueTickFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
